import CustomMainVerify from '@comp/CustomVerify';
import CustomFailed from '@root/components/CustomFailed';
import CustomSuccess from '@root/components/CustomSuccess';
import {
  formVerifyData,
  getNomadLifeContentData
} from '@root/constants/formData';
import {
  nomadLifeVerify,
  nomadLifeVerifyFailed,
  nomadLifeVerifySuccess
} from '@root/constants/paths';

const { main } = getNomadLifeContentData();

export const getNomadLifeVerifyRoutes = () => [
  {
    path: nomadLifeVerify(),
    element: (
      <CustomMainVerify
        mainContent={main}
        formData={formVerifyData}
        redirectPaths={{
          success: nomadLifeVerifySuccess,
          failed: nomadLifeVerifyFailed
        }}
      />
    )
  },
  {
    path: nomadLifeVerifySuccess(),
    element: <CustomSuccess />
  },
  {
    path: nomadLifeVerifyFailed(),
    element: <CustomFailed />
  }
];
